/*
* @Author: Gang Jiang
* @Date: 2026-03-05 11:14:54
* @LastEditors: 蒋刚 gang.jiang@mail.dealmoon.com
* @LastEditTime: 2026-03-05 11:15:23
*/

<template>
  <div class="payments" ref="zjdgx">
    <div class="bread-crumb">
      Payment
      <span>
        {{
          route.params.type === 'dm-received'
            ? 'DM Received'
            : route.params.type === 'pending-payment'
              ? 'Payments for KOL'
              : activeTab
        }}
      </span>
    </div>
    <h2>Payment</h2>
    <div class="content">
      <a-tabs v-model:activeKey="activeTab" @change="handleTabChange" :destroyInactiveTabPane="true">
        <a-tab-pane key="dmReceived" tab="DM Received">
          <DmReceived />
        </a-tab-pane>
        <a-tab-pane key="pendingPayment" tab="Payments for KOL">
          <Pending />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import Pending from './Pending.vue'
import DmReceived from './DmReceived.vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

/**
 * 将kebab-case参数转为camelCase: dm-received -> dmReceived, pending-payment -> pendingPayment
 */
function kebabToCamel(str) {
  return str
    ? str.replace(/-([a-z])/g, (_, c) => c.toUpperCase())
    : ''
}

const activeTab = ref(route.params.type ? kebabToCamel(route.params.type) : 'dmReceived')

// 检测URL变化，更新activeTab
watch(
  () => route.params.type,
  (newType) => {
    activeTab.value = newType ? kebabToCamel(newType) : 'dmReceived'
  }
)

const handleTabChange = (key) => {
  const camelToKebab = (str) => str.replace(/[A-Z]/g, m => '-' + m.toLowerCase())
  activeTab.value = key
  router.push(`/payments/${camelToKebab(key)}`)
}
</script>

<style lang="less" scoped>
.payments {
  max-width: 100%;

  .bread-crumb {
    >span {
      cursor: pointer;
      margin-left: 25px;
      position: relative;

      &:before {
        top: -1px;
        left: -14px;
        content: '/';
        font-size: 14px;
        color: #999;
        position: absolute;
      }
    }
  }

  .content {
    max-width: 100%;
    margin-top: 16px;
    background: none;
  }

  :deep(.filter) {
    padding: 20px;
    margin-bottom: 20px;
    background: #fff;
    border-radius: 4px;
    max-width: 100%;
    box-sizing: border-box;

    .ant-col {
      min-width: 0;
    }

    .ant-form-item-control-input {
      min-width: 0;
    }

    .ant-select,
    .ant-picker {
      width: 100% !important;
      max-width: 100%;
    }

    .filter-date-picker.ant-picker {
      width: 100% !important;
      max-width: 100%;
    }

    .btns {
      width: 100%;
      text-align: right;
      white-space: nowrap;
      min-width: 0;
    }

    .ant-btn {
      margin-left: 16px;
    }

    .ant-form-item {
      margin-bottom: 0;
    }

    @media (max-width: 768px) {
      padding: 12px;

      .btns {
        text-align: left;
      }

      .ant-btn {
        margin-left: 0;
        margin-right: 8px;
      }
    }
  }

  .table-wrapper {
    margin-top: 16px;
    overflow-x: auto;
    max-width: 100%;
  }

  :deep(.payments-table) {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    min-width: 800px;
  }

  @media (max-width: 768px) {
    :deep(.payments-table) {
      padding: 8px;
    }
  }

  :deep(.status-tag) {
    &.pending {
      color: #faad14;
    }

    &.confirmed {
      color: #52c41a;
    }
  }

  :deep(.action-links) {
    display: flex;
    flex-direction: column;
    gap: 4px;

    a {
      color: #1890ff;
      &.text-danger {
        color: #ff4d4f;
      }
    }
  }

  :deep(.payment-confirm-modal) {
    .ant-modal-content {
      border-radius: 12px;
      padding: 24px 32px 28px;
    }

    .payment-confirm-modal__header {
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 24px;
    }

    .reference-amount {
      color: #999;
      margin-bottom: 20px;
    }

    .payment-confirm-modal__form {
      .finance-amount-item {
        .ant-form-item-row {
          gap: 20px;
          display: flex;
          align-items: center;
          flex-direction: row;
        }

        .ant-form-item-label {
          max-width: 180px;
          margin-bottom: 0;
          padding-bottom: 0;
          line-height: 18px;
        }

        .ant-form-item-control {
          flex: 1;
          margin-bottom: 0;
          height: 36px;
        }

        .ant-input-affix-wrapper {
          padding-top: 5px;
          padding-bottom: 5px;
        }

        .ant-form-item-explain-error {
          margin-top: 4px;
          line-height: 16px;
        }
      }

      .ant-form-item-label>label {
        font-weight: 500;
      }

      .bank-rate-item {
        margin-bottom: 24px;
      }

      .bank-rate-warning {
        display: flex;
        color: #ff4d4f;
        font-size: 14px;
        margin-top: 4px;
        font-weight: 500;
        align-items: center;
        justify-content: space-between;
      }

      .bank-rate-label {
        display: flex;
        font-size: 14px;
        align-items: center;
        justify-content: space-between;

        .value {
          font-weight: 700;
          margin-left: 4px;
        }
      }
    }

    .payment-confirm-modal__footer {
      gap: 12px;
      display: flex;
      margin-top: 8px;
      justify-content: right;
    }
  }
}
</style>